import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Component to enforce trailing slashes on all URLs for SEO consistency
 * Redirects non-trailing-slash URLs to their trailing-slash equivalents
 */
const TrailingSlashRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // Skip home page
    if (pathname === '/') {
      return;
    }

    // If URL doesn't end with trailing slash, redirect to trailing slash version
    if (!pathname.endsWith('/')) {
      const newPath = `${pathname}/${search}${hash}`;
      navigate(newPath, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default TrailingSlashRedirect;
